<mat-toolbar class="no-background">
  <span>お問い合わせ詳細</span>
  <span class="spacer"></span>
  <a mat-button class="add-link" routerLink="/inquiry">
    <mat-icon>arrow_back</mat-icon>戻る
  </a>
</mat-toolbar>

<div class="inquiry-container" *ngIf="inquiry">

  <div class="inquiry-header">
    <div class="inquiry-title">{{ inquiry.title }}</div>
    <div class="inquiry-meta">
      <app-label-chip [status]="inquiry.status"></app-label-chip>
    </div>
  </div>

  <div class="child-list">
    <div class="child-item" *ngFor="let child of inquiry.children">
      <div class="child-header">
        <strong>{{ getUserName(child.user_id) }}</strong>
        <span class="child-date">{{ child.created_at | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
      </div>
      <div class="child-body">{{ child.body }}</div>

      <div *ngIf="child.attachments && child.attachments.length > 0">
        <h4>添付ファイル :</h4>

        <ul class="attachments">
          <li *ngFor="let file of child.attachments">
            <a (click)="downloadAttachment(file.id)" class="attachment-link">
              <mat-icon>file_open</mat-icon>{{ file.filename }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="complete-section" *ngIf="inquiry.status !== '完了'">
    <div>
      <span class="complete-message">お問い合わせが解決した場合は、下記にチェックを入れて「完了」を押してください</span>
      <label for="visibleCompleteCheck" style="margin-top: 8px;"><input type="checkbox" id="visibleCompleteCheck" [(ngModel)]="visibleCompleteButton">お問い合わせを終了します</label>
    </div>
    <button mat-raised-button color="accent" type="button" [disabled]="!visibleCompleteButton" (click)="markAsCompleted()">完了</button>
  </div>

  <div class="complete-section" *ngIf="inquiry.status === '完了' || inquiry.status === '回答済'">
    <button mat-raised-button color="accent" type="button" (click)="inquiry.status='対応中'">お問い合わせを再開する</button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data" *ngIf="inquiry.status !== '完了' && inquiry.status !== '回答済'">

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>返信（1000文字まで）</mat-label>
      <textarea matInput formControlName="body" rows="6" required></textarea>
      <mat-hint align="end">
        <span *ngIf="form.get('body')?.invalid && form.get('body')?.touched" class="inline-error">
          返信は必須です　
        </span>
        <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
          返信は1000文字以内で入力してください　
        </span>
        {{ form.get('body')?.value?.length || 0 }}/1000
      </mat-hint>
    </mat-form-field>

    <input type="file" #fileInput hidden multiple (change)="onFileChange($event)" />

    <div class="drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <p>ここにファイルをドロップまたは</p>
      <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
      <p></p>
      <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

      <mat-list>
        <mat-list-item *ngFor="let file of selectedFiles; let i = index">
          <div class="file-row">
            <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
              <mat-icon>delete</mat-icon>
            </button>
            <span class="file-size">
              ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
            </span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
        </mat-list-item>
      </mat-list>

    </div>

    <div class="upload-hint">
      <mat-hint align="end">{{ selectedFiles.length || 0 }}/10</mat-hint>
    </div>

    <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
      {{ form.get('files')?.getError('maxFileSize')?.message }}
    </mat-error>

    <div style="text-align: right;">
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
        返信を登録
      </button>
    </div>

  </form>
</div>
